export const MORE_ABOUT_LABELS = {
	title: 'Want To Know More?',
	content: 'Schedule a demo with our Retail Audience Engagement Manager',
	buttonText: 'Schedule Now',
	buttonLink: ''
};
